<template>
  <div class="nav-bar-box">
    <div class="top-title">
      <div class="top-select">
        <span class="top-select-course">{{selectOption.course}}</span>
        <span class="top-select-option">{{selectOption.phase}}-{{selectOption.edition}}-{{selectOption.volume}}</span>
      </div>

      <div @click='openListBtn' class="select-img">
        <img src="~@/assets/img/resourceCenter/select.png" alt="图片">
      </div>
    </div>

    <div class="select-view">
      <div class="nav-bar-list">
        <div class="nav-bar-item" v-for="(item,index) of arr" :key='item.title+index'>
          <!-- 选择框 -->
          <div :class="backClass(`select-box-${item.type}`)" class="select-box">
            <el-dropdown @visible-change='visibleChange($event,item.type)' trigger="click">
              <div class="select-btn">
                <span>{{item.title}}</span>
                <i class="el-icon-arrow-down "></i>
              </div>
              <!-- 辅助显示隐藏功能 -->
              <el-dropdown-menu :popper-class="'select-option-'+item.type" slot="dropdown">
              </el-dropdown-menu>
            </el-dropdown>

            <!-- 展示选项列表 -->
            <div :id='"select-option-"+item.type' class="select-option">
              <div class="option-before"></div>
              <div class="option-after"></div>
              <div v-show="item.optionArr.length!=0">
                <el-radio @change='optionChange($event,item.type)' v-for="(value,i) of item.optionArr"
                  :key="value.name+i" v-model="selectArr[index][item.type]" :label="value.name">
                </el-radio>
              </div>

              <el-radio v-if='item.optionArr.length==0' :label="placeholder(item.type)"> </el-radio>

            </div>
          </div>

          <!-- 展示选中的 -->
          <div class="checked-content">

            <el-tooltip class="item" effect="light" :enterable='false' popper-class='checked-content-tooltip'
              placement="right">
              <div class="tooltip-content" slot="content">{{selectArr[index][item.type]}}</div>
              <div class="checked-content-item">{{selectArr[index][item.type]}}</div>
            </el-tooltip>

          </div>
        </div>

        <div @click='closeListBtn' class="close-list">
          <span>确定</span>
        </div>

      </div>
    </div>

    <div class="side-nav">
      <SyncTreeNav @handleNodeClick='handleNodeClick' :treeData='treeData' :defaultProps='defaultProps' />
    </div>
  </div>

</template>

<script>
import $ from "jquery";
import SyncTreeNav from "@/views/resourceCenter/components/syncTextBookResource/components/SyncTreeNav";
import {
  getDictBatch,
  getChapterTree,
  getLabelSearch,
} from "@/network/resourceRequest/api";

export default {
  name: "SyncNavBarList",
  components: {
    SyncTreeNav,
  },

  data() {
    return {
      //循环列表
      arr: [],
      //绑定选项
      //course学科,phase学段,grade年级,volume册别,edition教材版本,qtype题型,ptype试卷类型,bookType类型
      selectArr: [],
      //提交的选项数据
      selectOption: {},
      // 侧边树形导航--------------------------------------------
      treeData: [],
      // 侧边树形导航--------------------------------------------
      defaultProps: {
        children: "children",
        label: "name",
      },
      //筛选列表是否打开
      isShowSelectList: false,
    };
  },

  created() {
    this.init();
  },

  methods: {
    //初始化数据
    init() {
      //获取字典
      //course学科,phase学段,grade年级,volume册别,edition教材版本,qtype题型,ptype试卷类型,bookType类型
      let data = {
        types: "phase,course,qtype,ptype,grade,edition,volume",
      };

      //初始化选择数据
      getDictBatch(data).then((res) => {
        if (res.data.success) {
          let resultInfo = res.data.data;
          //添加学段
          this.addArr("选择学段", "phase", resultInfo);
          //添加学科
          this.addArr("选择学科", "course", resultInfo);
          //添加版本
          this.addArr("选择版本", "edition", resultInfo);
          //添加年级
          this.addArr("选择年级", "grade", resultInfo);
          //添加册别
          this.addArr("选择册别", "volume", resultInfo);
        }
      });
    },

    //选择
    optionChange(label, type) {
      this.$set(this.selectOption, type, label);

      if (type == "phase") {
        this.updatePhase();
      }

      if (type == "course") {
        this.updateCourse();
      }

      if (type == "edition") {
        this.updateEdition();
      }

      if (type == "grade") {
        this.updateGrade();
      }
    },

    //提示语--------------------------------------------
    placeholder(type) {
      switch (type) {
        case "phase":
          return "暂无数据";
          break;
        case "course":
          return "请先选择学段";
          break;
        case "edition":
          return "请先选择学科";
          break;
        case "grade":
          return "请先选择版本";
          break;
        case "volume":
          return "请先选择年级";
          break;
      }
    },

    //学段更新时更新学科、版本、年级、册别
    updatePhase() {
      getLabelSearch({
        labels: this.selectOption.phase,
        type: "course",
      }).then((res) => {
        if (res.data.success) {
          //修改科目的选项数组--------------------------------------------
          this.arr.forEach((item, i) => {
            if (item.type == "course") {
              this.$set(this.arr[i], "optionArr", res.data.data);
            } else if (item.type != "phase") {
              this.$set(this.arr[i], "optionArr", []);
            }
          });

          //修改默认值--------------------------------------------
          this.selectArr.forEach((item, index) => {
            if (Object.keys(item)[0] != "phase") {
              //修改显示数组
              this.selectArr[index][Object.keys(item)[0]] = "请选择";
              this.selectOption[Object.keys(item)[0]] = "请选择";
            }
          });
        } else {
          console.log(res.data.code);
        }
      });
    },

    //学科更新时更新版本、年级、册别
    updateCourse() {
      let labelList = [];
      labelList.push(this.selectOption.phase);
      labelList.push(this.selectOption.course);
      getLabelSearch({
        labels: labelList.join(","),
        type: "edition",
      }).then((res) => {
        if (res.data.success) {
          //修改选项数组--------------------------------------------
          this.arr.forEach((item, i) => {
            if (item.type == "edition") {
              this.$set(this.arr[i], "optionArr", res.data.data);
            } else if (item.type == "grade" || item.type == "volume") {
              this.$set(this.arr[i], "optionArr", []);
            }
          });

          //修改默认值--------------------------------------------
          this.selectArr.forEach((item, index) => {
            if (
              Object.keys(item)[0] != "phase" &&
              Object.keys(item)[0] != "course"
            ) {
              //修改显示数组
              this.selectArr[index][Object.keys(item)[0]] = "请选择";
              this.selectOption[Object.keys(item)[0]] = "请选择";
            }
          });
        }
      });
    },

    //版本更新时更新年级、册别
    updateEdition() {
      let labelList = [];
      labelList.push(this.selectOption.phase);
      labelList.push(this.selectOption.course);
      labelList.push(this.selectOption.edition);

      getLabelSearch({
        labels: labelList.join(","),
        type: "grade",
      }).then((res) => {
        if (res.data.success) {
          //修改选项数组--------------------------------------------
          this.arr.forEach((item, i) => {
            if (item.type == "grade") {
              this.$set(this.arr[i], "optionArr", res.data.data);
            } else if (item.type == "volume") {
              this.$set(this.arr[i], "optionArr", []);
            }
          });

          //修改默认值--------------------------------------------
          this.selectArr.forEach((item, index) => {
            if (
              Object.keys(item)[0] == "grade" ||
              Object.keys(item)[0] == "volume"
            ) {
              //修改显示数组
              this.selectArr[index][Object.keys(item)[0]] = "请选择";
              this.selectOption[Object.keys(item)[0]] = "请选择";
            }
          });
        }
      });
    },

    //年级更新时更新册别
    updateGrade() {
      let labelList = [];
      labelList.push(this.selectOption.phase);
      labelList.push(this.selectOption.course);
      labelList.push(this.selectOption.edition);
      labelList.push(this.selectOption.grade);
      getLabelSearch({
        labels: labelList.join(","),
        type: "volume",
      }).then((res) => {
        if (res.data.success) {
          //修改选项数组--------------------------------------------
          this.arr.forEach((item, i) => {
            if (item.type == "volume") {
              this.$set(this.arr[i], "optionArr", res.data.data);
            }
          });

          //修改默认值--------------------------------------------
          this.selectArr.forEach((item, index) => {
            if (Object.keys(item)[0] == "volume") {
              //修改显示数组
              this.selectArr[index][Object.keys(item)[0]] = "请选择";
              this.selectOption[Object.keys(item)[0]] = "请选择";
            }
          });
        }
      });
    },

    //下拉框显示和隐藏
    visibleChange(flag, name) {
      if (flag) {
        //按钮激活样式
        $(`.select-box-${name}`).css({ borderColor: "#24ba58" });

        //显示自定义下拉框
        $(`#select-option-${name}`).css({ display: "flex" });

        //取消默认下拉框
        $(`[popper-class="select-option-${name}"]`).css({
          margin: 0,
          padding: 0,
          border: 0,
          overflow: "hidden",
        });
      } else {
        $(`#select-option-${name}`).css({ display: "none" });
        $(`.select-box-${name}`).css({ borderColor: "#e5e5e5" });
      }
    },

    //打开筛选列表
    openListBtn() {
      if (!this.isShowSelectList) {
        this.isShowSelectList = !this.isShowSelectList;
        let height = $("#cloud-resource-nav-bar").height();
        $(".select-view").css("height", height - 60);
        $(".select-view").css("overflow", "visible");
      } else {
        this.isShowSelectList = !this.isShowSelectList;
        $(".select-view").css("height", 0);
        $(".select-view").css("overflow", "hidden");
      }
    },

    //关闭筛选列表条件
    closeListBtn() {
      this.getKnowledge(this.selectOption);
      $(".select-view").css("height", "0");
      $(".select-view").css("overflow", "hidden");
      this.isShowSelectList = !this.isShowSelectList;
    },

    //返回类名
    backClass(name) {
      return name;
    },

    //添加数据
    addArr(title, type, resultInfo) {
      if (resultInfo[type]) {
        this.arr.push({
          title: title,
          type: type,
          optionArr: type == "phase" ? resultInfo[type] : [],
        });

        let obj = {};
        obj[type] = "请选择";
        this.selectArr.push(obj);

        //提交发射出去的数据
        this.$set(this.selectOption, type, "请选择");
      }
    },

    //提交选项
    emitSelectOption(chapterId) {
      this.$set(this.selectOption, "chapterId", chapterId);
      this.$emit("selectOption", this.selectOption);
    },

    //选择的知识点
    handleNodeClick(data) {
      this.$set(this.selectOption, "chapterId", data.id);
      this.emitSelectOption(data.id);
    },

    //获取知识点
    getKnowledge(data) {
      getChapterTree(data).then((res) => {
        if (res.data.success) {
          this.treeData = res.data.data;
          if (res.data.data.length != 0) {
            this.emitSelectOption(res.data.data[0].id);
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.nav-bar-box {
  position: relative;

  width: 100%;
  .top-title {
    display: flex;

    border-radius: 2px 2px 0 0;
    padding: 0 20px;
    height: 60px;

    box-shadow: 0 1px 0 0 rgba(229, 229, 229, 1);

    align-items: center;
    justify-content: space-between;

    .top-select {
      display: flex;

      width: 160px;

      flex-direction: column;

      .top-select-course {
        overflow: hidden;

        margin-bottom: 6px;

        font-size: 14px;
        font-weight: bold;
        white-space: nowrap;
        text-overflow: ellipsis;

        color: rgba(51, 51, 51, 1);
      }

      .top-select-option {
        overflow: hidden;

        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
        text-overflow: ellipsis;

        color: rgba(102, 102, 102, 1);
      }
    }

    .select-img {
      position: relative;

      width: 20px;

      cursor: pointer;

      img {
        width: 20px;
      }
    }
  }

  .select-view {
    overflow: hidden;

    position: absolute;
    top: 60px;
    right: 0;
    z-index: 1;

    width: 100%;
    height: 0;

    background-color: #fff;

    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);

    transition: all 0.3s;

    .nav-bar-list {
      padding: 0 20px;
      .nav-bar-item {
        display: flex;

        border-bottom: 1px #ccc dashed;
        width: 100%;
        height: 60px;

        align-items: center;
        justify-content: space-between;

        .select-box {
          position: relative;

          margin-right: 10px;
          border: 1px solid rgba(229, 229, 229, 1);
          border-radius: 2px;
          width: 100px;
          height: 32px;

          background: rgba(255, 255, 255, 1);

          .el-dropdown {
            width: 100%;
            height: 100%;

            cursor: pointer;

            .select-btn {
              display: flex;

              width: 100%;
              height: 100%;

              align-items: center;
              justify-content: center;
              span {
                margin-right: 5px;

                font-size: 12px;

                color: #333;
              }
            }
          }

          .select-option:hover {
            // box-shadow: rgba(0, 0, 0, 0.5) 0 0 10px 0;
            box-shadow: rgba(36, 186, 88, 0.5) 0 0 7px 0;

            transform: translateY(-1px);
          }

          .select-option {
            display: none;

            position: absolute;
            top: 45px;
            left: -1px;
            z-index: 100;

            border: 1px #24ba58 solid;
            min-width: 300px;

            background-color: #fff;

            flex-wrap: wrap;

            .option-before {
              position: absolute;
              top: -20px;
              left: 40px;

              border-top: 10px solid rgba(0, 0, 0, 0);
              border-right: 10px solid rgba(0, 0, 0, 0);
              border-bottom: 10px solid #24ba58;
              border-left: 10px solid rgba(0, 0, 0, 0);
            }

            .option-after {
              position: absolute;
              top: -19px;
              left: 40px;

              border-top: 10px solid rgba(0, 0, 0, 0);
              border-right: 10px solid rgba(0, 0, 0, 0);
              border-bottom: 10px solid #fff;
              border-left: 10px solid rgba(0, 0, 0, 0);
            }

            .el-radio {
              margin: 10px;
            }

            .el-radio:hover {
              /deep/ .el-radio__label {
                color: #24ba58;
              }
            }

            /deep/ .el-radio__input {
              display: none;
            }
            /deep/ .el-radio__label {
              padding-left: 0;

              font-size: 14px;
              font-weight: 400;

              color: rgba(51, 51, 51, 1);
              color: #333;
            }

            /deep/ .el-radio__input.is-checked + .el-radio__label {
              color: #24ba58;
            }
          }
        }

        .checked-content {
          overflow: hidden;

          font-size: 14px;
          font-weight: bold;
          text-align: end;
          white-space: nowrap;
          text-overflow: ellipsis;

          color: rgba(36, 186, 88, 1);

          flex: 1;

          .checked-content-item {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .close-list {
        display: flex;

        margin: 20px auto;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 5px;
        height: 40px;

        font-size: 12px;
        text-align: center;

        color: #333;

        cursor: pointer;

        align-items: center;
        justify-content: center;
      }

      .close-list:hover {
        color: #fff;
        background-color: #24ba58;
      }
    }
  }

  .side-nav {
    padding: 20px 20px 0;
  }
}
</style>

